'use strict';
(function () {
    App.directive('cardLifePackage', cardLifePackage);
    cardLifePackage.$inject = ['Config', '$state', 'lifeInsuranceService', 'Blob', 'FileSaver'];
    function cardLifePackage(Config, $state, lifeInsuranceService, Blob, FileSaver) {
        return {
            restrict: 'AEC',
            scope: {
                package: '=',
                person: '='
            },
            templateUrl: Config.TEMPLATES_DIR + 'Components/card-life-package.html',
            link: function(scope) {
                scope.determineCardType = function () {
                    if (!scope.package.revision.lifeInsurance || !scope.package.revision.lifeInsurance.status) {
                        return 'orange';
                    }
                    switch (scope.package.revision.lifeInsurance.status) {
                        case 'ACTIVE':
                            return 'orange';
                        case 'NEW':
                            return 'orange';
                        default:
                            return 'orange';
                    }
                };

                scope.next = function () {
                    $state.go('root.life.details', {package: scope.package});
                };

                scope.getDeclaration = function(ev, declaration) {
                    var id = declaration.uuid,
                        barcode = declaration.barcode;

                    lifeInsuranceService.getDeclarationFile(id).then(function (response) {
                        var data = new Blob([response.data], { type: 'application/pdf' });
                        FileSaver.saveAs(data, 'Deklaracja_' + barcode + '.pdf');
                    });
                };


                scope.editDeclaration = function () {
                    var declarationEntity = scope.package, person = scope.person;
                    $state.go('root.life.edit', {
                        declarationEntity: declarationEntity,
                        person: angular.extend(person, {type: declarationEntity.declaration.type}),
                    });
                };
            }
        }
    }
})();
